import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, NumberBox, SelectBox, TagBox } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeContractorNomenclatureMutation,
  useCreateContractorNomenclatureMutation,
  useLazyGetContractorNomenclatureDetailQuery,
} from 'bus/contractorNomenclaturePrice/services/services';
import { ContractorNomenclaturePriceDetail } from 'bus/contractorNomenclaturePrice/types';
import { useGetRequestDestinyQuery } from 'bus/request';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  contractorId: number | null;
};

const initialForm: ContractorNomenclaturePriceDetail = {
  contractorId: null,
  dateBegin: undefined,
  factoryId: null,
  objectIds: [],
  objectId: null,
  factoryIds: [],
  nomenclatureId: null,
  paymentMethod: null,
  price: undefined,
  density: 4,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, contractorId }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<ContractorNomenclaturePriceDetail>(initialForm);

  const [paymentMethods, setPaymentMethods] = useState([]);

  const [getContractorNomenclatureDetail] = useLazyGetContractorNomenclatureDetailQuery();
  const [createContractorNomenclature, { isLoading: isLoadingCreate }] = useCreateContractorNomenclatureMutation();
  const [changeContractorNomenclature, { isLoading: isLoadingChange }] = useChangeContractorNomenclatureMutation();
  const { data } = useGetRequestDestinyQuery();

  const disabledSubmit = isLoadingCreate || isLoadingChange;

  const onShown = async () => {
    const storeFactory = $createDataSource('/v1/ContractorNomenclaturePrice/types', 'id');

    storeFactory.load().then(setPaymentMethods);

    if (id) {
      getContractorNomenclatureDetail({ id }).unwrap().then(setForm);
    } else {
      setForm(initialForm);
    }
  };

  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  const materialDataSource: DataSource = useMemo(() => {
    return $createDataSource('/v1/Nomenclature', 'id');
  }, []);

  const objectDataStore: DataSource = useMemo(() => {
    const defaultFilter = [['parentId', '=', null], 'and', ['type', '=', 1]];
    return $createDataSource(`/v1/ContractorObject/${contractorId}`, 'id', { defaultFilter });
  }, [contractorId]);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        delete form.factoryIds;
        await changeContractorNomenclature({ ...form, id, contractorId })
          .unwrap()
          .then(() => {
            changeVisible(false);
            refresh();
          });
      } else {
        delete form.factoryId;
        await createContractorNomenclature({ ...form, contractorId })
          .unwrap()
          .then(() => {
            changeVisible(false);
            refresh();
          });
      }
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        showTitle={true}
        title="Цена за куб"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
        showCloseButton
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Способ оплаты" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={paymentMethods}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.paymentMethod}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, paymentMethod: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions
                              title="Выберите способ оплаты"
                              closeOnOutsideClick={true}
                              showTitle={false}
                            />
                            <Validator>
                              <RequiredRule message="Выберите способ оплаты" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Объект" labelTop>
                          {!id ? (
                            <TagBox
                              stylingMode="underlined"
                              dataSource={objectDataStore}
                              displayExpr="address"
                              valueExpr="id"
                              showSelectionControls={true}
                              onValueChanged={(e) => {
                                setForm((prev) => ({ ...prev, objectIds: e.value }));
                              }}
                            >
                              <DropDownOptions title="Выберите объект" closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите объект" />
                              </Validator>
                            </TagBox>
                          ) : (
                            <SelectBox
                              stylingMode="underlined"
                              dataSource={objectDataStore}
                              displayExpr="address"
                              valueExpr="id"
                              value={form.objectId}
                              onItemClick={(e) => {
                                setForm((prev) => ({ ...prev, objectId: e.itemData.id }));
                              }}
                            >
                              <DropDownOptions title="Выберите объект" closeOnOutsideClick={true} showTitle={false} />
                            </SelectBox>
                          )}
                        </AppFiledBox>

                        <AppFiledBox label="Площадка" labelTop>
                          {!id ? (
                            <TagBox
                              stylingMode="underlined"
                              dataSource={factoryDataStore}
                              displayExpr="name"
                              valueExpr="id"
                              showSelectionControls={true}
                              onValueChanged={(e) => {
                                setForm((prev) => ({ ...prev, factoryIds: e.value }));
                              }}
                            >
                              <DropDownOptions title="Выберите площадку" closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите площадку" />
                              </Validator>
                            </TagBox>
                          ) : (
                            <SelectBox
                              stylingMode="underlined"
                              dataSource={factoryDataStore}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.factoryId}
                              onItemClick={(e) => {
                                setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                              }}
                            >
                              <DropDownOptions title="Выберите площадку" closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите площадку" />
                              </Validator>
                            </SelectBox>
                          )}
                        </AppFiledBox>
                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, dateBegin: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Рецепт" labelTop>
                          <div className="d-flex align-center">
                            <SelectBox
                              stylingMode="underlined"
                              style={{ width: '100%' }}
                              dataSource={materialDataSource}
                              displayExpr="comment"
                              valueExpr="id"
                              value={form.nomenclatureId}
                              onValueChange={(e) => {
                                setForm((prev) => ({ ...prev, nomenclatureId: e }));
                              }}
                              searchEnabled
                            >
                              <DropDownOptions title="Выберите рецепт" closeOnOutsideClick={true} showTitle={false} />
                              <Validator>
                                <RequiredRule message="Выберите рецепт" />
                              </Validator>
                            </SelectBox>
                          </div>
                        </AppFiledBox>

                        <AppFiledBox label="Подвижность" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите подвижность"
                            mode="text"
                            value={form.density}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, density: e }));
                            }}
                            displayExpr="name"
                            valueExpr="id"
                            dataSource={data}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле подвижность" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Цена за куб" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="укажите цену за куб"
                            mode="text"
                            value={form.price}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, price: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле цена за куб" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={disabledSubmit}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
